import React from "react";
import H from "../../../common/Typography/H";
import HorizontalSlider from "../../../common/HorizontalSlider";
import image1 from "../../../../assets/images/b2b-examples/1.jpg";
import image2 from "../../../../assets/images/b2b-examples/2.jpg";
import image3 from "../../../../assets/images/b2b-examples/3.jpg";
import image4 from "../../../../assets/images/b2b-examples/4.jpg";
import image5 from "../../../../assets/images/b2b-examples/5.jpg";
import image6 from "../../../../assets/images/b2b-examples/6.jpg";

import styles from "./examples.module.scss";

function Examples() {
  return (
    <div className={styles.root}>
      <H level={3} className={styles.title}>
        Примеры работ
      </H>
      <HorizontalSlider
        className={styles.slider}
        dots={false}
        variableWidth
        centerMode={false}
        centerPadding={0}
        slidesToShow={6}
        infinite={false}
        responsive={[
          {
            breakpoint: 2275,
            settings: {
              slidesToShow: 5
            }
          },
          {
            breakpoint: 1715,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 1240,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 925,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 585,
            settings: {
              centerMode: true,
              slidesToShow: 1
            }
          }
        ]}
      >
        {[
          {
            src: image1,
            alt: `3Д-футболки сублимационная печать на синтетике`
          },
          {
            src: image2,
            alt: `прямая печать на детских футболках`
          },
          {
            src: image3,
            alt: `дай пять!`
          },
          {
            src: image4,
            alt: `прямая печать логотипа на футболке wearcraft`
          },
          {
            src: image5,
            alt: `Шелкография (5 цветов)`
          },
          {
            src: image6,
            alt: `Поло - прямая печать`
          }
        ].map(({src, alt}, i) => (
          <img loading="lazy" key={i} src={src} alt={alt} className={styles.example} />
        ))}
      </HorizontalSlider>
    </div>
  );
}

Examples.propTypes = {};

export default Examples;
